import { useMutation, UseMutationOptions } from 'react-query';
import client from 'client';

const useSaveSeat = (
    eventId: number,
    sessionId: number,
    ticketId: number,
    options: UseMutationOptions = {}
) => {
    const saveSeatMutation = useMutation(() => {
        return client().put(
            `/api/v2/agenda/events/${eventId}/sessions/${sessionId}/register/${ticketId}`
        );
    }, options);

    return saveSeatMutation;
};

export default useSaveSeat;
